<app-header></app-header>
<app-navbar></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <!-- Tabla de tipos de IVA -->
        <div class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{
                    'sidebar.ivaTypes' | translate }}</h2>
                <button type="button" class="btn custombutton" (click)="newVat()">
                    {{ 'buttons.newIva' | translate }}
                </button>
            </div>
        </div>

        @if (this.vatResponse.vatRateTypeDto && this.vatResponse.vatRateTypeDto.length > 0) {
        <div>
            <fieldset role="radiogroup">
                <table id="table1" class="table" [attr.aria-label]="'sidebar.ivaTypes' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col"><span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'typesVat.description' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of this.vatResponse.vatRateTypeDto; let i = index"
                            [ngClass]="{ 'resaltado': selectedRowId === row.idVatRate }">
                            <td role="gridcell">
                                <input type="radio" id="checkboxRate-{{row.idVatRate}}" name="checkboxRate"
                                    [checked]="selectedRowId === row.idVatRate" (click)="toggleRow(row)" />
                                <label for="checkboxRate-{{row.idVatRate}}" class="visually-hidden">
                                    {{ row.vatRateTraductionDto?.[0]?.description || 'Seleccione IVA' }}
                                </label>
                            </td>
                            <td role="gridcell">
                                <span *ngIf="row.vatRateTraductionDto">
                                    {{ row.vatRateTraductionDto[0].description }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
            <div class="mt-2" *ngIf="this.vatResponse.pageDto">
                <app-paginator (controlEmited)="controlPaginator($event)" [control]="'vatResponse'"
                    [isStart]="this.vatResponse.pageDto.start" [isEnd]="this.vatResponse.pageDto.end"
                    [currentPage]="this.vatResponse.pageDto.currentPage" [totalPages]="this.vatResponse.pageDto.pages"
                    [numberRecord]="this.vatResponse.pageDto.records" [sizePage]="this.vatResponse.pageDto.pageSize">
                </app-paginator>
            </div>
        </div>
        }

        <!-- Formulario de tasas administrativas -->
        @if (vatFormVisible) {
        <div>
            <div>
                <div class="separator mt-5"></div>
                <h2 class="mb-3 mt-4 textformat">{{
                    'sidebar.ivaTypes' | translate }}</h2>
            </div>
            <form [formGroup]="vatForm">
                <div class="row">
                    <div class="col">
                        <label for="descriptionCat">{{ 'administrativeTaxes.catDescription' | translate
                            }}<span>*</span></label>
                        <input type="text" id="descriptionCat" name="descriptionCat" class="form-control"
                            placeholder="Ingrese la descripción en catalán" formControlName="descriptionCat"
                            aria-required="true" />
                    </div>
                    <div class="col">
                        <label for="descriptionCast">{{ 'administrativeTaxes.castDescription' | translate
                            }}<span>*</span></label>
                        <input type="text" id="descriptionCast" name="descriptionCast" class="form-control"
                            placeholder="Ingrese la descripción en castellano" formControlName="descriptionCast"
                            aria-required="true" />
                    </div>
                    <div class="col">
                        <label for="descriptionIng">{{ 'administrativeTaxes.engDescription' | translate
                            }}<span>*</span></label>
                        <input type="text" name="descriptionIng" id="descriptionIng" class="form-control"
                            placeholder="Ingrese la descripción en inglés" formControlName="descriptionIng"
                            aria-required="true" />
                    </div>
                </div>
                <div class="row d-flex">
                    <div class="col-12 mt-4">
                        <button type="button" class="btn cancelbutton me-2" (click)="onCancel()">Cancelar</button>
                        <button type="button" class="btn custombutton" (click)="saveOrUpdateVatRate()">
                            {{ selectedRowId!=null ? ('buttons.modify' | translate) : ('buttons.save' | translate) }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        }

        @if(selectedRowId!=null){
        <div class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{
                    'sidebar.sectionsVat' | translate }}</h2>
                <button type="button" class="btn custombutton" (click)="newTypeVat()">
                    {{ 'buttons.newRegister' | translate }}
                </button>
            </div>
        </div>

        @if (typeVatResponse && typeVatResponse.listVatRateType.length>0) {
        <fieldset>
            <table id="table2" class="table mt-3 mb-3" [attr.aria-label]="'sidebar.sectionsVat' | translate">
                <thead>
                    <tr role="row">
                        <th scope="col">
                            <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                        </th>
                        <th scope="col">{{ 'typesVat.percentage' | translate }}</th>
                        <th scope="col">{{ 'typesVat.date' | translate }}</th>
                        <th scope="col">{{ 'typesVat.endDate' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of typeVatResponse.listVatRateType; let id=index"
                        [ngClass]="{ 'resaltado': datePK === row.idVatRateTypePkDto?.startDate}">
                        <td role="gridcell">
                            <input type="radio" id="checkboxVat-{{row.idVatRateTypePkDto?.startDate}}"
                                name="checkboxVat" [checked]="datePK === row.idVatRateTypePkDto?.startDate"
                                (click)="toggleRowTypes(row)" />
                            <label for="checkboxVat-{{row.idVatRateTypePkDto?.startDate}}" class="visually-hidden">
                                {{ row.vatPercentage }}%
                            </label>
                        </td>
                        <td role="gridcell">{{ row.vatPercentage }}</td>
                        <td role="gridcell">{{ row.idVatRateTypePkDto?.startDate | date:'dd/MM/yyyy' }}</td>
                        <td role="gridcell">{{ row.endDate | date:'dd/MM/yyyy' }}</td>
                    </tr>
                </tbody>
            </table>
        </fieldset>
        <div class="mt-2" *ngIf="this.typeVatResponse.pageDto">
            <app-paginator (controlEmited)="controlPaginator($event)" [control]="'typeVatResponse'"
                [isStart]="this.typeVatResponse.pageDto.start" [isEnd]="this.typeVatResponse.pageDto.end"
                [currentPage]="this.typeVatResponse.pageDto.currentPage"
                [totalPages]="this.typeVatResponse.pageDto.pages" [numberRecord]="this.typeVatResponse.pageDto.records"
                [sizePage]="this.typeVatResponse.pageDto.pageSize">
            </app-paginator>
        </div>
        }
        }

        @if (typesVatFormVisible) {
        <form [formGroup]="typesVatForm">
            <div class="row">
                <div class=" col-4">
                    <label for="percentage">{{ 'typesVat.percentage' | translate }}<span>*</span></label>
                    <input type="number" id="percentage" name="percentage" class="form-control"
                        formControlName="percentage" [min]="0" [max]="100" aria-required="true" />
                </div>
                <div class="col-4">
                    <label for="startDate">{{ 'typesVat.date' | translate }}<span>*</span></label>
                    <input type="date" name="startDate" id="startDate" class="form-control" formControlName="startDate"
                        aria-required="true" />
                </div>
                <div class="col-4">
                    <label for="endDate">{{ 'typesVat.endDate' | translate }}</label>
                    <input type="date" id="endDate" name="endDate" class="form-control" formControlName="endDate" />
                </div>
            </div>
        </form>
        <div class="row d-flex">
            <div class="col-12 mt-4">
                <button type="button" class="btn cancelbutton me-2" (click)="onCancelType()">Cancelar</button>
                <button type="button" class="btn custombutton" (click)="saveOrUpdateVatRateType()">
                    {{ selectedTypesRowId !=null ? ('buttons.modify' | translate) : ('buttons.save' | translate) }}
                </button>
            </div>
        </div>
        }

        <app-alert-component [isOk]="messageVisibility.isSuccessSecond" [isDanger]="messageVisibility.isErrorSecond"
            [message]="errorMessage"
            (close)="messageVisibility.isSuccessSecond = messageVisibility.isErrorSecond = false"></app-alert-component>

        <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
            [message]="errorMessage"
            (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
    </main>
</div>